import React from 'react'
import { render } from 'react-snapshot'

import App from './App'
import { unregister as unregisterServiceWorker } from './serviceWorker'

// do not initialise firebase when we are creating the static pages
if (!navigator.userAgent.match(/Node\.js/i)) {
  require('./firebase')
}

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregisterServiceWorker()
